import { GetConversationSummary, GetWhatsappConversations, PostWhatsappUser } from "../../../actionTypes/whatsapp";

export function postWhatsappUser() {
  return {
    type: PostWhatsappUser.REQUEST,
  };
}

export function getWhatsappConversationsAction(talentId: string) {
  return {
    type: GetWhatsappConversations.REQUEST,
    talent: talentId,
  };
}

export function fetchConversationSummaryAction(talentId: string) {
  return {
    type: GetConversationSummary.REQUEST,
    talent: talentId,
  };
}

export function clearWhatsappConversationsAction() {
  return {
    type: GetWhatsappConversations.SUCCESS,
    payload: [],
  };
}
